import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseComponent } from '../../../../../../../../models/base/base-component';
import { StiiizyAddressCardStackContentViewModel } from '../stiiizy-address-card-stack-content-view-model';
import { StiiizyCardData } from '../../../../../../../../models/print-cards/stiiizy-card-data';

@Component({
  selector: 'app-stiiizy-address-product-information',
  templateUrl: './stiiizy-address-product-information.component.html',
  styleUrls: ['./stiiizy-address-product-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class StiiizyAddressProductInformationComponent extends BaseComponent {
  constructor(
    public viewModel: StiiizyAddressCardStackContentViewModel // provided by parent component
  ) {
    super();
  }

  @Input() cardData: StiiizyCardData;

  setupBindings() {}

  setupViews() {}
}
